import { MsBookmark as o } from "@sunrise/icons";
import { defineComponent as m } from "vue";
const e = m({
  name: "CsBookmarkIcon",
  components: {
    MsBookmark: o
  },
  props: {
    hasDot: Boolean
  }
});
export {
  e as default
};
